export default __webpack_public_path__ + "static/media/fo.83c3d998.svg";